import State from './State.js';
export default class StateStarter extends State {
    constructor(context) {
        super(context);
        this.name = 'starter';
    }
    setup() {

        //flip top card
        let deck = this.context.getPile("deck");
        let starterCard = deck[deck.length - 1];
        let dealer = this.context.dealer;
        starterCard.showfront = false;
        this.context.sendEvent("cardMoved");

        //The player on the dealer's left cuts the undealt portion of the deck (leaving at least 4 cards), 
        //and the dealer reveals the top card, called the "starter" or the "cut", placing it on top of the deck face up. 
        //(It is illegal to peek at any other cards in the deck during this process.)
        //[3] If this card is a Jack, the dealer scores two points for "his heels", 
        //also known as "his nibs", or simply "nibs".The game can end on a cut of a Jack for the dealer.

        //get points 
        if (starterCard.number === 11) {
            this.context.awardPoints(2, dealer, "his heels", "starter", [starterCard]);

        }
        //state may change to "endMatch" because of "awardPoints()"
        //if game over and state is set to "endMatch", setState("play") will freeze the game
        if (this.context.currentState !== "endMatch")
            this.context.setState("play");
    }
    action(command, value, player) {
        switch (command) {
            default: this.unknownCommand(command, value, player);
        }
    }
    getActions(player) {
        let actions = [];
        return actions;
    }

    unknownCommand(command, value, player) {
        this.context.unknownCommand(command, null, player);
    }

}